import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { RamiFormComponent } from './dialogs/form/form.component';
import { RamiRoutingModule } from './rami-routing.module';
import { RamiComponent } from './rami.component';



@NgModule({
  declarations: [RamiComponent, RamiFormComponent],
  imports: [
    CommonModule,
    RamiRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ]
})
export class RamiModule { }
